import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { NgLocalStorage } from 'core/utils/ng-storage.service';
import { MsalService } from 'msal';
import { AuthenticationService } from 'core/authentication.service';

@Directive({
  selector: '[appDisabledElement]'
})
export class DisabledElementDirective implements OnInit {
  @Input() appDisabledElement;
  @Input() isparentlocked;
  @Input() isrecordlocked;
  constructor(private eleRef: ElementRef, private ngLocalStorage: NgLocalStorage, private msalService: MsalService, private _auth: AuthenticationService) { }
  disableClass() {
    this.eleRef.nativeElement.style.cursor = 'not-allowed';
    this.eleRef.nativeElement.style.pointerEvents = 'auto';
  };
  enableClass() {
    this.eleRef.nativeElement.style.cursor = 'pointer';
    this.eleRef.nativeElement.style.pointerEvents = 'auto';
  };
  ngOnInit() {
    let response = JSON.parse(this.ngLocalStorage.getItem('PDMUserRoles'));
    let view = true;
    let edit = false;
    let roles = this._auth.getUserRoles(this.msalService);
    let userRolePermissions = [];
    roles.forEach((value, key) => {
      userRolePermissions = response.filter((item) => { return item.RoleName === value });
      if (userRolePermissions.length != 0) {
        if (userRolePermissions[0][this.appDisabledElement]) {
          edit = true;
        }
      }
    });
    if (this.isparentlocked == "true" || this.isparentlocked == "1" || this.isrecordlocked == "true") {
      this.disableClass();
    } else {
      edit ? this.enableClass() : this.disableClass();
    }

  }
}
